import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import config from '../../configuration/config';
import { useHistory } from "react-router";
import ConfirmContext from "../../utils/confirmContext";
import _ from 'lodash';
import Popup from "../../User/popup";
import { getData } from "../../utils/localStorageManager";


export function OrderDraftsCheckPage({ ...props }) {
    const history = useHistory();
    const thisConfirmContext = useContext(ConfirmContext);
    const { orderGuid } = useParams();
    const location = useLocation();
    const { t: trans, i18n } = useTranslation(["new", "finance", "cartFile", "info", "new"]);


    let lang = (i18n.language || 'ar');
    const [showFinalPopupMessage, setShowFinalPopupMessage] = useState("");

    const [sadadInfo, setSadadInfo] = useState(null);
    const [dataFinalPopup, setDataFinalPopup] = useState({});
    const [dataOrderDraft, setDataOrderDraft] = useState({});
    const [showStstusLodingPopup, setShowStstusLodingPopup] = useState(false);
    const [showFinalPopup, setShowFinalPopup] = useState(false);


    const siteSalesOrderDraftResponse = {
        SiteSalesOrderDraftID: "SOD251007001",
        CustID: null,
        CustContactID: null,
        Description: null,
        DescriptionAr: null,
        SalesOrderDate: null,
        ValidUntil: null,
        DeliveryDate: null,
        CurrencyID: "SR",
        NetTotalBeforeDisc: 0,
        DiscountTotal: 0,
        NetTotalAfterDisc: 0,
        DocumentReference: null,
        DocumentDate: null,
        SiteID: null,
        StoreID: null,
        SalesOrderStatusID: "Ready for payment",
        CustPaymentMethodID: null,
        DelivaryAddress: null,
        Note: null,
        CreatedDate: "2025-10-05T04:36:03.000Z",
        CreatedUSer: "Dev_HJ",
        PostedDate: null,
        PostedUSer: null,
        SalesManID: null,
        Dim1ID: null,
        Dim2ID: null,
        Dim3ID: null,
        Dim4ID: null,
        Dim5ID: null,
        CostCenterID: null,
        SalesQuotationID: null,
        GUID: "B596EC59-6B91-49CF-A508-1CC2933F21EC",
        Company: null,
        PLanningOrder: 0,
        PromisedDate: null,
        EstimationID: null,
        EstimationGUID: null,
        BillingType: null,
        Version: null,
        retention: null,
        Advanced: null,
        ProjectProfitPercent: null,
        StartDate: "2025-01-01T00:00:00.000Z",
        EndDate: null,
        ProjectDuratin: null,
        OriginalContract: null,
        OriginalContractID: null,
        BudgetGUID: null,
        BudgetID: null,
        ContractType: null,
        OriginTypeID: null,
        RouteID: null,
        TripFrom: null,
        TripTo: null,
        TripHour: null,
        ContractTypeID: null,
        ContractIdentificationCode: null,
        DriverID: null,
        VehicleID: null,
        AttachmentID: null,
        ContractID: null,
        Internal: null,
        External: null,
        Collections: null,
        TotalCollectionsAmount: 0,
        SectionID: 0,
        PumpDoorNo: null,
        NetTotalExclTax: null,
        Dealtwith: null,
        ProfitPercentTotal: null,
        GrossProfit: null,
        TotalCost: null,
        TaxExempt: null,
        YearIsnotIncludedintheTaxes: null,
        DiscountForAll: null,
        TotalTax: 0,
        ReqDownPayment: 0,
        OverrideDownPayment: null,
        PaidAmount: null,
        SalesReservationID: null,
        AuthorizedToReceiveVehicle: null,
        AuthorizedToReceiveGTP: null,
        AuthorizedName: null,
        AuthorizedPassport: null,
        AuthorizedID: null,
        AuthorizedMobile: null,
        AuthorizedCRNo: null,
        AuthorizedNationality: null,
        AuthorizationImage: null,
        CustGroupID: 0,
        PurchOrderID: null,
        PurchOrderMemo: null,
        PurchOrderDate: null,
        PriceListTypeID: null,
        SalesValidTimebyMin: 0,
        Expire: 0,
        ExtexndBy: null,
        SalesInvoiceID: null,
        SalesInvoiceTarget: null,
        PrintAll: null,
        PrintForEach: null,
        PaymentTypeID: null,
        SalesTypeID: null,
        AffiliateCustomer: 0,
        MobAffiliateCustomer: 0,
        IDAffiliateCustomer: null,
        AffiliateCustID: null,
        Reference: null,
        Slug: "338E44CC-4EA1-4A37-8F56-444EA5F67EB4",
        Model: "Corolla Cross",
        BrandID: "TN965",
        ProductGroupID: "Corolla Cross 2023",
        Type: "089/30",
        ColorID: "FBAFA7EC-474D-4A8C-BC25-322345590D78",
        SN: "RKLKCBAG4S0522921",
        ProductID: 94300,
        UOMID: 1,
        Amount: 94300,
        NetTotalBeforeDiscTrans: 94600,
        NetTotalAfterDiscTrans: 109535,
        CashBack: 0,
        Transportation: 600,
        OtherAmount: 260,
        BankCommission: 0,
        PlateFees: 400,
        Select: 1,
        Discount: 0,
        AmountIncludingTax: 14235,
        TaxPercent: 15,
        NetTotalExclTaxTrans: 94900,
        SalesConditionID: 0,
        ColorDescEn: "Platinum White Pearl MC./Terra Rosa",
        ColorDescAr: "ابيض لؤلؤي بلاتينم / أحمر",
        Message: "Invoice is Not paid",
        Status: "success",
        TranRef: 6145156,
        ResponseText: null,
        OrderId: "SOD251005008",
        SadadNumber: null,
        url_payment: "https://demo.MyFatoorah.com/KWT/ia/050724274614515662-86d450f4"
    };





    useEffect(() => {

        fetchOrderDraftPaymentStatus();
    }, []);


    useEffect(() => {

    }, []);




    const fetchOrderDraftPaymentStatus = async () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var id = orderGuid?.trim();
        if (!id) return;


        setShowStstusLodingPopup(true);
        try {
            const response = await axios.post(`${config.controllURL}api/Payment/OrderDraftPaymentStatus`, null, {
                headers: myHeaders,
                params: { ID: id },
                responseType: "json"
            });

            const responseData = response?.data;
            // const responseData = siteSalesOrderDraftResponse;

            setDataOrderDraft(responseData);
            setShowStstusLodingPopup(false);

            if (!responseData) return;

            let data = Array.isArray(responseData)
                ? responseData[0]
                : responseData;

            console.log("data:", data);
            if (!data) return;
            if (data.Status === "notPaid") {

                setShowFinalPopup(true);
                setShowFinalPopupMessage(trans("new:Payment_was_not_completed_Purchase_process_failed"));

                return;
            }


            if (data.Status === "success") {
                if (data?.SadadNumber) setSadadInfo(data.SadadNumber);
                setShowFinalPopup(true);
                setShowFinalPopupMessage( trans("new:payment_success") );
                setDataFinalPopup(data);
            } else if (data?.ResponseText) {
                try {
                    const jsonData = JSON.parse(data.ResponseText);
                    // console.log("IsSuccess:", jsonData.IsSuccess);
                    // console.log("InvoiceStatus:", jsonData.Data?.InvoiceStatus);

                    if (jsonData.IsSuccess == true && jsonData.Data?.InvoiceStatus) {
                        setShowFinalPopup(true);
                        // setShowFinalPopupMessage(data?.Message);
                        setShowFinalPopupMessage(trans("يرجاء التاكد من عملية الدفع , يبدو انها لم تتم او قد تحتاج تاكيد من المسوؤل  "));
                        data["InvoiceStatus"] = jsonData.Data?.InvoiceStatus;
                        setDataFinalPopup(data);
                    }
                } catch (error) {
                    console.error("Invalid JSON:", error);
                }

            } else if (data?.Message) {
                setShowFinalPopup(true);
                setShowFinalPopupMessage(data?.Message);
                setDataFinalPopup(data);

            } else if (data?.ErrorMessage) {
                alert(`${data.ErrorMessage} / ${data?.ErrorProcedure || ""}`);
            }

        } catch (error) {
            console.error("Error fetching payment status:", error);
        }
    };

    return (
        <>

            <Popup show={showFinalPopup}>
                <div className="w-full  flex flex-column justify-center items-center" >
                    <div className="cart-finalized" >
                        <div className="cart-finalized-container flex flex-col">

                            <div className="cart-finalized-container-img flex flex-col">
                                <img src="/assets/images/finalized.svg" alt="" />
                            </div>

                            <div className="flex flex-wrap justify-center">
                                <span className="text-20 font-bold text-black mx-2 unselectable ">{trans("new:thank_to_choose")}</span>
                                <span className="text-20 font-bold text-primary mx-2"> {trans("new:HJ_cars")}</span>
                            </div>

                            {showFinalPopupMessage &&
                                <>
                                    <div className="flex mt-10 flex-wrap justify-center mx-20">
                                        <span className="text-24 text-gray  mx-2"> {showFinalPopupMessage}</span>
                                    </div>

                                </>

                            }
                            {dataFinalPopup?.InvoiceStatus &&
                                <>
                                    <div className="flex flex-wrap justify-center mx-20">
                                        {/* <span className="text-24 text-gray  mx-2"> {trans("new:payment_status") + ":"}</span> */}
                                        <span className="text-24 text-gray  mx-2"> {dataFinalPopup?.InvoiceStatus}</span>
                                    </div>

                                </>

                            }
                            {
                                dataFinalPopup &&
                                <>

                                    {
                                        dataFinalPopup?.OrderId &&
                                        <div className="flex flex-row justify-center cart-finalized-code"
                                            onClick={() => {

                                                navigator.clipboard.writeText(dataFinalPopup?.OrderId);
                                            }}

                                        >

                                            <span className="text-20 font-bold text-white  mx-2"> {trans("info:order-number") + " :"}</span>
                                            <span className="text-20 font-bold text-white  mx-2">{dataFinalPopup?.OrderId && dataFinalPopup?.OrderId}</span>
                                            <img src="/assets/icons/copy.svg" alt='' />
                                        </div>
                                    }
                                </>

                            }

                            {
                                sadadInfo &&
                                <>

                                    <div className="flex mt-10  flex-wrap justify-center mx-20">
                                        <span className="text-24 text-center text-gray  mx-2"> {trans("new:a_payment_number_has_already_been_created")
                                            + " " + trans("new:to_avoid_order_cancellation")
                                            + " " + trans("new:within_24_hours")}</span>
                                    </div>

                                    <div className="flex cart-finalized-code flex-row nice-align-item-center"
                                        onClick={() => {

                                            navigator.clipboard.writeText(sadadInfo);
                                        }}
                                    >
                                        <div className=" bg-white border-radius p-1 ">
                                            <img className=" object-contain" width={50} height={50}
                                                src={"/assets/icons/companies/SADAD-Logo.png"} alt={"SADAD"} />
                                        </div>
                                        {
                                            <div className="flex flex-row justify-center  mt-2">

                                                {/* <span className="text-20 font-bold text-white  mx-2"> {trans("new:sadad") + " :"}</span> */}
                                                <span className="text-20 font-bold text-white  mx-2">{sadadInfo}</span>

                                            </div>
                                        }
                                        <img src="/assets/icons/copy.svg" alt='' />
                                    </div>

                                </>

                            }



                            <div className="flex nice-flex-center  nice-align-item-center nice-flex-space-between w-100  gap-5 justify-items-auto 
                            py-10 px-20  my-20 ">

                                <div className="col-span-12 md:col-span-5 sm:col-span-5 lg:col-span-5 xl:col-span-5"></div>
                                <div className="col-span-12 md:col-span-5 sm:col-span-5 lg:col-span-5 xl:col-span-5">

                                    <div className={"btn nice-flex-row  py-5 px-5 text-white text-24 " + ((dataFinalPopup && dataFinalPopup?.OrderId && dataFinalPopup?.StatusPaymentID === "FullyPaid") ? " bg-primary " : " bg-gray ")}
                                        onClick={async () => {

                                            if (dataFinalPopup && dataFinalPopup?.OrderId && dataFinalPopup?.StatusPaymentID === "FullyPaid") {
                                                // You can await here
                                                const isLogin = getData('isAuthenticated');
                                                console.log("isLogin:", isLogin);
                                                if (isLogin) {
                                                    history.push({
                                                        pathname: `/car/accessories/${dataFinalPopup?.SN}/${dataFinalPopup?.Slug}`,
                                                        search: `orderDraftID=${orderGuid}`
                                                    });
                                                    //   history.push("/user/myOrders");
                                                } else {

                                                    thisConfirmContext.onShowRegistrationPup(true,
                                                        `/car/accessories/${dataFinalPopup?.SN}/${dataFinalPopup?.Slug}?orderDraftID=${orderGuid}`);

                                                }
                                            }

                                        }}




                                    >{(dataFinalPopup && dataFinalPopup?.OrderId) ? trans("cartFile:comlete_buying") : trans("new:Create_New")}
                                        <div className={" mx-2 " + (lang == "ar" ? " rotate-180 " : "")}>

                                            <svg xmlns="http://www.w3.org/2000/svg" height="15" width="20" viewBox="0 0 448 512" >
                                                <path fill="#ffffff" strokeWidth="2" d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" />
                                            </svg>

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </Popup>
            <Popup show={showStstusLodingPopup && !showFinalPopup}>
                <div className="w-full  flex flex-column justify-center items-center" >
                    <div className="cart-finalized" >
                        <div className=" flex flex-column justify-center items-center gap-5">

                            <div className=" flex flex-col gap-3">
                                <img src="/assets/Loding_new.svg" width={120} height={120} alt="Loding" />

                                <span className="text-20 font-bold  text-primary mx-2 unselectable ">{trans("new:thank_you_for_order")}</span>
                            </div>

                            <div className="flex flex-wrap flex-column justify-center">
                                {/* <span className="text-20 font-bold text-blackmx-2"> {trans("new:نقوم الآن بمعالجة الطلب،.")}</span> */}
                                <span className="text-20 font-bold text-blackmx-2"> {trans("new:order_number_soon")}</span>
                            </div>

                            {showFinalPopupMessage &&
                                <>
                                    <div className="flex mt-10 flex-wrap justify-center mx-20">
                                        <span className="text-24 text-gray  mx-2"> {showFinalPopupMessage}</span>
                                    </div>

                                </>

                            }

                        </div>

                    </div>
                </div>
            </Popup>
        </>
    );
}